import { useSyncExternalStore } from "react";

// Release 1.5.0 switch on the SPA side. The API says whether 1.5.0 is on (GET /api/v1/auth/config → release150, from
// Release150:Enabled); main.tsx stores the answer here before the first render. Off (the default, and whenever the API
// cannot be asked) means every screen behaves exactly as in 1.4.0. Shared by every 1.5.0 feature.

let enabled = false;
const listeners = new Set<() => void>();

export function setRelease150(value: boolean): void {
  if (enabled === value) return;
  enabled = value;
  listeners.forEach((l) => l());
}

/** The current value, for code outside React (query client set-up, listeners). */
export function isRelease150(): boolean {
  return enabled;
}

/** The current value, for components; re-renders if it changes (tests flip it). */
export function useRelease150(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
    () => enabled,
    () => enabled
  );
}
